module.exports = __webpack_public_path__ + "static/media/w2.7f6663cf.png";